module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "prologue"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Prologue")])])]), _c('a', {
    attrs: {
      "id": "prologue"
    }
  }, [_c('p', {
    staticClass: "chapsub"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Washington University\n                Hospital Baltimore"), _c('br'), _vm._v("October 7, 1849")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Edgar?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Speaking softly, Dr. Moran leaned over his patient. His eyes traced the\n            wan and pallid countenance of the famous poet, Edgar Poe. But the man who lay on the\n            hospital bed before him now, bathed in the dim yellow lamplight, bore little resemblance\n            to his dignified portraits. He seemed, instead, more like a ghostly shell of that man, a\n            wasted imposter, his cheeks shadow-sunken, his skin waxen, white as the sheets beneath\n            him. Dark lashes fringed his bruise-purple lids, serving to blacken the deep\n            crescent-shaped hollows beneath each eye. Sweat glistened on his broad brow, less from\n            fever and more, the doctor knew, from exertion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rain pattered against the vaulted Gothic windows, glittering crystal beads\n            that quivered into long streaks against the backdrop of darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though morning approached, the shadows of night pervaded the otherwise\n            empty room.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prologue"
    }
  }, [_vm._v("Outside, the wind moaned, while the clop of horses’ ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("hooves and the rattle of carriage wheels echoed from the alley below.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Edgar,” Moran spoke again, “can you hear me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poe’s eyes drifted lazily open, glassy and distant, like the\n            sightless eyes of a child’s doll, black as inkwells. He stared at the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moran checked his patient’s pulse, his thumb and finger clasping the\n            clammy skin of the poet’s wrist. There, a racing throb marked the seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The doctor hesitated. He did not wish to send his patient into a frenzy\n            yet again. Still, he could not help but press for another moment of lucidity, another\n            brief glimmer of the man locked within the mania. Another clue to the puzzle of what had\n            happened four days ago, when Poe had been brought into his care, delirious, covered from\n            head to foot in ashen grit, insensible, dressed in another man’s clothing and\n            unable to relate a single coherent detail as to where he had been—or who he had\n            been with, for that matter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you remember where you are?” Moran asked. The doctor\n            shifted in his seat, and the old wooden chair creaked beneath him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly Poe’s arm shot out. He grasped for the doctor, locking his\n            wrist in a grip that held all the strength of rigor mortis. “Who is it?”\n            Edgar gasped, a rattle sounding in his chest, his voice husky, raw from the hours of\n            screaming. “Who is here?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("“Be calm,” Moran urged. He allowed Edgar’s clammy grip\n            to remain, hoping that the physical contact would somehow ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("ground him,\n            that it could bring him back, tether him to reality.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Reynolds?” Poe whispered. His hand tightened around\n            Moran’s wrist with unbelievable strength, quivering with urgency. “Reynolds\n            . . . tell me that you’ve come at last.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The doctor swallowed. He wet his lips, which fought to form words before\n            he knew what to say. “It is Dr. Moran, Edgar. Your physician. As I’m sure\n            you remember.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poe’s face contorted. His eyes squeezed shut. His mouth opened, the\n            corners collapsing in silent anguish. He released the doctor, his grip falling limp.\n            “I should have known,” he moaned, every syllable dripping the blackest\n            despair, “that you would leave me here. Like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Edgar,” Moran whispered, “I wish only to help. Can you\n            tell me what happened? Can you tell me how you came to be in Baltimore?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I am not,” Poe said, rocking his head back and forth\n            against the damp pillow. With these words, his breathing turned shallow and quick. A\n            shudder ran through him, causing the bed itself to tremble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moran frowned at his patient and groped for what next to say, for whatever\n            words might keep Poe’s mind present, distracted from hallucination, from the\n            entities he claimed he saw slipping through the walls in swirls of black smoke.\n            “Mr. Poe, you mentioned yesterday that you had a wife. In Richmond. Can you tell\n            me—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“Almost,” Poe whispered. “Almost. But then, Reynolds, I\n                "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("have")]), _vm._v(" a wife.” With these words, he traced his\n            fingertips lightly across his chest, over a place where a portion of his shirt lay ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("open. “Here. All the while,” he murmured. “Locked\n            within this feverish heart. All the while.”")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who is this Reynolds you speak of?” Moran asked. “A\n            friend, perhaps?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps,” Poe replied, his hand falling away as he fixated on\n            the ceiling. “We shall see. The shadows gather. Can you hear them whispering?\n                "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("She")]), _vm._v(" is coming. And so we shall see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poe’s eyes grew wider then, their centers expanding, black as\n            pitch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moran watched, transfixed. He had treated delirium many times before. But\n            what was it about this man’s condition that made him want to steal a glance at the\n            barren walls that encircled them, to be certain that there was truly nothing there?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Edgar gasped. His body went rigid. Arching his spine, he threw his head to\n            one side and howled. Writhing, he gripped the bed beneath him, twisting the fabric of\n            the matted bedclothes, crying out, “REYNOLDS!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moran shot to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“REYNOLDS!” Poe screamed again, renewing the cry that had\n            carried him through the night, his voice now raw and ragged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Edgar!” Moran shouted, grasping for his patient’s hand.\n            “Edgar, you are "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("safe")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“REYNOLDS!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There is nothing here that can harm you. Edgar, listen to me!\n            It’s over. Do you hear me? Whatever has happened, it is over!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Poe froze in that moment, his teeth gritted, his face\n            fraught with agony, beads of sweat sliding down his temples.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Then something in him changed. He seemed to return to himself all at once,\n            like the flickering flame of a candle that had managed to steady itself after a gust of\n            cold wind. His body began to relax and he sank slowly into the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the first time, his gaze turned to lock with Moran’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The doctor stared, unblinking, stricken as he watched the blackened\n            centers of Poe’s eyes recede, like clouds from a storm-ravaged sea, revealing the\n            bright rims of two blue-gray irises.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poe stared at him with sudden intensity and intelligence, present for the\n            first time. “Is it?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he exhaled, Poe’s hand grew limp in the doctor’s grip.\n            “Lord help my poor soul,” he breathed, even as the glow within those bright\n            and glittering eyes dimmed, fading as fast as it had come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Edgar,” Moran called.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But it was too late, for the eyes that stared up at him now, wide and\n            sightless, held their strange light no more.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 69
// module chunks = 0